import React, { useState } from 'react';
import { Loading } from '../../../redux/action';
import { connect } from 'react-redux';
import { Tabs, Tab } from "react-bootstrap";
import Positive from '../../../assets/images/positive.png';
import Negative from '../../../assets/images/negative.png';
import Neutral from '../../../assets/images/neutral.png';
import { DefaultUserProfile } from '../../../config/config';

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  paidComments: any;
  organicComments: any;
  totalCommentsCount: any;
}

const CommentsTab: React.FC<Props> = ({ paidComments, organicComments }) => {
  const [paidTabKey, setPaidTabKey] = useState("positive");
  const [organicTabKey, setOrganicTabKey] = useState("positive");

  // ORGANIC
  const organicPositive = organicComments.filter((c: any) => c.score > 0);
  const organicNeutral = organicComments.filter((c: any) => c.score === 0);
  const organicNegative = organicComments.filter((c: any) => c.score < 0);
  const totalOrganic = organicPositive.length + organicNeutral.length + organicNegative.length;

  // PAID
  const paidPositive = paidComments.filter((c: any) => c.score > 0);
  const paidNeutral = paidComments.filter((c: any) => c.score === 0);
  const paidNegative = paidComments.filter((c: any) => c.score < 0);
  const totalPaid = paidPositive.length + paidNeutral.length + paidNegative.length;

  const getPercentage = (count: number, total: number) =>
    total > 0 ? ((count / total) * 100).toFixed(0) : '0';

  // Percentages
  const organicPositivePercent = getPercentage(organicPositive.length, totalOrganic);
  const organicNegativePercent = getPercentage(organicNegative.length, totalOrganic);
  const organicNeutralPercent = getPercentage(organicNeutral.length, totalOrganic);

  const paidPositivePercent = getPercentage(paidPositive.length, totalPaid);
  const paidNegativePercent = getPercentage(paidNegative.length, totalPaid);
  const paidNeutralPercent = getPercentage(paidNeutral.length, totalPaid);

  const renderCommentList = (comments: any[]) => (
    <ul className='comment-tab-content-list'>
      {comments.map((item, index) => (
        <li className='comment-tab-content-item' key={index}>
          <img
            className='comment-tab-content-item-img'
            src={DefaultUserProfile.influencer_unknown_default}
            alt=''
            style={{ width: '40px', height: '40px', borderRadius: '50%' }}
          />
          <div className='comment-tab-content-item-detail'>
            <span className='comment-tab-content-item-user'>{item.user_commenting}</span>
            <span className='comment-tab-content-item-user-comment'>{item.comments}</span>
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <div className='row'>
      {/* Paid Comments Section */}
      <div className='col-md-6'>
        <div className='brand-insight-highchart comment-analysis-tab-sec'>
          <div className="brand-insight-highchart-top">
            <strong className="brand-insight-highchart-title d-flex flex-column">
              Comment Analysis - Paid
            </strong>
          </div>
          <div className='brand-insight-highchart-data'>
            <Tabs
              activeKey={paidTabKey}
              onSelect={(k) => setPaidTabKey(k || "positive")}
              className="comment-analysis-tab"
            >
              <Tab
                eventKey="positive"
                title={<><img className='me-1' src={Positive} alt="" /> Positive <strong>{paidPositivePercent}%</strong></>}
                className='comment-tab-content'
              >
                {renderCommentList(paidPositive)}
              </Tab>
              <Tab
                eventKey="negative"
                title={<><img className='me-1' src={Negative} alt="" /> Negative <strong>{paidNegativePercent}%</strong></>}
                className='comment-tab-content'
              >
                {renderCommentList(paidNegative)}
              </Tab>
              <Tab
                eventKey="neutral"
                title={<><img className='me-1' src={Neutral} alt="" /> Neutral <strong>{paidNeutralPercent}%</strong></>}
                className='comment-tab-content'
              >
                {renderCommentList(paidNeutral)}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

      {/* Organic Comments Section */}
      <div className='col-md-6'>
        <div className='brand-insight-highchart'>
          <div className="brand-insight-highchart-top">
            <strong className="brand-insight-highchart-title d-flex flex-column">
              Comment Analysis - Organic
            </strong>
          </div>
          <div className='brand-insight-highchart-data'>
            <Tabs
              activeKey={organicTabKey}
              onSelect={(k) => setOrganicTabKey(k || "positive")}
              className="comment-analysis-tab"
            >
              <Tab
                eventKey="positive"
                title={<><img className='me-1' src={Positive} alt="" /> Positive <strong>{organicPositivePercent}%</strong></>}
                className='comment-tab-content'
              >
                {renderCommentList(organicPositive)}
              </Tab>
              <Tab
                eventKey="negative"
                title={<><img className='me-1' src={Negative} alt="" /> Negative <strong>{organicNegativePercent}%</strong></>}
                className='comment-tab-content'
              >
                {renderCommentList(organicNegative)}
              </Tab>
              <Tab
                eventKey="neutral"
                title={<><img className='me-1' src={Neutral} alt="" /> Neutral <strong>{organicNeutralPercent}%</strong></>}
                className='comment-tab-content'
              >
                {renderCommentList(organicNeutral)}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(CommentsTab);

export { connectToRedux as CommentsTab };
